// extracted by mini-css-extract-plugin
module.exports = {"qna":"qna_qna__3zGnS","header":"qna_header__MBsMA","desc":"qna_desc__3S2ty","main":"qna_main__bQGTe","dialogs":"qna_dialogs__3zBsR"};